import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Modal, Row, Form } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { SessionContext } from "../SessionProvider";

const CreateAssignmentModal = (props) => {

  console.log('props-->',props.assignData)
  const { selectedSessionId } = useContext(SessionContext);
  const [classOptions, setClassOptions] = useState([]);
  const [sessionOptions, setSessionOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [assignsubject, setAssignsubject] = useState([]);
   const [isSubmitting, setIsSubmitting] = useState(false);
  const [assignmentData, setAssignmentData] = useState({
    class_id: "",
    subject_id: "",
    section_id: "",
    due_date: new Date(),
    assign_date: new Date(),
    status: "",
    title: "",
    description: "",
    session_id: selectedSessionId ? selectedSessionId : "",
    document: null,
  });
  const [files, setFiles] = useState([]);
  const [fileDescription, setFileDescription] = useState("");
  const [fileName, setFileName] = useState("");

  const [assignmentStatus, setAssignmentStatus] = useState([
    { value: "assigned", label: "Assigned" },
    { value: "inprogress", label: "In Progress" },
    { value: "completed", label: "Completed" },
    { value: "cancelled", label: "Cancelled" },
  ]);

  useEffect(() => {
    if (props.assignData) {
      let [day, month, year] = props.assignData.due_date.split("-");
      let dueDate = new Date(year, month - 1, day);
      [day, month, year] = props.assignData.assign_date.split("-");
      let assignDate = new Date(year, month - 1, day);

      setAssignmentData({
        class_id: props.assignData.class_id,
        subject_id: props.assignData.subject_id,
        due_date: dueDate,
        assign_date: assignDate,
        status: props.assignData.status,
        title: props.assignData.title,
        description: props.assignData.description,
        session_id: props.assignData.session_id,
        section_id: props.assignData.section_id,
        document: props.assignData.file_id || null,
      });
      setFileName(props.assignData.file_title || "");
    } else {
      resetFormState();
    }
  }, [props.assignData]);

  useEffect(() => {
    async function fetchAllSessions() {
      try {
        const sessions = await schoolApi.fetchSessions();
        const sessionOptions = sessions?.result?.map((sess) => ({
          value: sess.id,
          label: sess.year,
        }));
        setSessionOptions(sessionOptions);
      } catch (error) {
        console.error("Error fetching sessions:", error);
      }
    }
    fetchAllSessions();
  }, []);

  useEffect(() => {
    async function handleClassChange() {
      try {
        let classId = assignmentData.class_id;

        if (classId) {
          let sectionList = await schoolApi.getSectionRecordById(classId);
          if (sectionList?.record && sectionList?.record?.length > 0) {
            let sectionOptions = sectionList?.record.map((item) => ({
              value: item.id,
              label: item.name,
            }));
            setSectionOptions(sectionOptions);

            const result = await schoolApi.getAllSubByClassId(classId);
            if (result.success) {
              let fetch = result?.records?.map((item) => ({
                label: item.subjectname,
                value: item.subject_id,
              }));
              setAssignsubject(fetch);
            } else {
              setAssignsubject([{ value: "", label: "No Records Found!!" }]);
            }
          } else {
            setSectionOptions([{ value: "", label: "No Records Found!!" }]);
          }
        } else {
          setSectionOptions([{ value: "", label: "No Records Found!!" }]);
          setAssignsubject([{ value: "", label: "No Records Found!!" }]);
        }
      } catch (error) {
        console.error("Error fetching class data:", error);
      }
    }
    handleClassChange();
  }, [assignmentData.class_id]);

  useEffect(() => {
    async function fetchAllClasses() {
      try {
        const classes = await schoolApi.getActiveClassRecords();
        if (classes.success) {
          const classOptions = classes?.result?.map((cls) => ({
            value: cls.id,
            label: cls.classname,
          }));
          setClassOptions(classOptions);
        } else {
          setClassOptions([]);
        }
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    }
    fetchAllClasses();
  }, []);

  const handleChange = (e) => {
    if (e.target.name === "class_id") {
      setAssignmentData({ ...assignmentData, [e.target.name]: e.target.value });
      setAssignmentData((prevState) => ({
        ...prevState,
        section_id: "",
        subject_id: "",
      }));
    } else {
      setAssignmentData({ ...assignmentData, [e.target.name]: e.target.value });
    }
  };

  const handleDocumentChange = (event) => {
    setFiles(event.target.files);
    setFileName(event.target.files[0]?.name || "");
  };

  const handleDateChange = (date, name) => {
    if (date) {
      setAssignmentData((prevData) => {
        const updatedData = { ...prevData, [name]: date };

        if (
          name === "assign_date" &&
          assignmentData?.due_date &&
          date > assignmentData.due_date
        ) {
          delete updatedData.due_date;
        }

        return updatedData;
      });
    }
  };

  console.log('assignmentData-->',assignmentData);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    if (
      assignmentData.class_id &&
      assignmentData.title &&
      assignmentData.subject_id &&
      assignmentData.status &&
      assignmentData.due_date &&
      assignmentData.section_id &&
      assignmentData.assign_date
    ) {
      if (props.assignData) {
        try {
          const result = await schoolApi.updateAssignment(
            props.assignData.id,
            assignmentData
          );
          if (!result.success) {
            return toast.error(result.message);
          }

          var formData = new FormData();
          for (let i = 0; i < files.length; i++) {
            formData.append(`files${i}`, files[i]);
            formData.append(`description`, fileDescription);
          }

          try {
            if (assignmentData.document === null) {
              if (props?.assignData?.file_id) {
                const deleteExistFile = await schoolApi.deleteFile(
                  props?.assignData?.file_id
                );
                if (!deleteExistFile.success) {
                  toast.error(deleteExistFile.message);
                }
              }

              if (props.assignData.id) {
                const fileResult = await schoolApi.createFile(
                  props.assignData.id,
                  formData
                );
              }
            } else {
              const exitFile = await schoolApi.fetchFileById(
                assignmentData.document
              );

              if (exitFile.success) {
                if (props?.assignData?.file_id && files.length > 0) {
                  const deleteExistFile = await schoolApi.deleteFile(
                    props?.assignData?.file_id
                  );
                  if (!deleteExistFile.success) {
                    toast.error(deleteExistFile.message);
                  }
                }

                let fileResult;
                if (files.length > 0) {
                  fileResult = await schoolApi.createFile(
                    props.assignData.id,
                    formData
                  );
                }

              }
            }

            if (result.success) {
              toast.success("Record updated successfully!");
              props.handleCloseModal();
              props.fetchAllAssignments();
              resetFormState();
            }
          } catch (error) {
            console.error("Error handling file:", error);
            setIsSubmitting(false);
          }
        } catch (error) {
          toast.error(error?.response?.data?.message);
          setIsSubmitting(false);
        }
        finally {
          setIsSubmitting(false);
        }
      } else {
        try {
          const result = await schoolApi.createAssignment(assignmentData);

          if (result.message === "This record already exists") {
            return toast.error(result.message);
          }

          console.log('files-on handleSubmit->',files);
          var formData = new FormData();
          for (let i = 0; i < files.length; i++) {
            formData.append(`files${i}`, files[i]);
            formData.append(`description`, fileDescription);
          }

          console.log('formData-on handleSubmit->',formData);

          try {
            const fileResult = await schoolApi.createFile(
              result?.result[0]?.id,
              formData
            );

            if (fileResult.success && result.success) {
              toast.success("Record created successfully!");
            } else {
              toast.success("Record created successfully!");
            }

            if (fileResult) {
              props.handleCloseModal();
              props.fetchAllAssignments();
              resetFormState();
            }
          } catch (error) {
            setIsSubmitting(false);
            console.error("Error creating file:", error);
          }
        } catch (error) {
          console.error("Error creating assignment:", error);
          setIsSubmitting(false);
        } finally {
          setIsSubmitting(false);
        }
      }
    } else {
      setIsSubmitting(false);
      return toast.error("Fill all required fields.");
    }
  };

  const resetFormState = () => {
    setAssignmentData({
      class_id: "",
      subject_id: "",
      due_date: new Date(),
      assign_date: new Date(),
      section_id: "",
      status: "",
      title: "",
      description: "",
      session_id: selectedSessionId ? selectedSessionId : "",
      document: null,
    });
    setFiles([]);
    setFileName("");
    setIsSubmitting(false);
  };

  console.log('files-->',files);

  return (
    <Modal
      show={props.modalShow}
      centered
      className="modal-dialog-scrollable"
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      onHide={() => {
        props.handleCloseModal();
        resetFormState();
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {props.assignData ? "Update Assignment" : "Create Assignment"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form className="mt-3">
          <Row>
            <Col lg={6}>
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Class</Form.Label>
                <Form.Select
                  name="class_id"
                  onChange={handleChange}
                  value={assignmentData.class_id}
                  required
                >
                  <option key="default" value="">
                    -- Select Class --
                  </option>
                  {classOptions.map((res) => (
                    <option key={res.value} value={res.value}>
                      {res.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col lg={6}>
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Section</Form.Label>
                <Form.Select
                  name="section_id"
                  onChange={handleChange}
                  value={assignmentData.section_id}
                  required
                >
                  <option key="default" value="">
                    -- Select Section --
                  </option>
                  {sectionOptions.map((res) => (
                    <option key={res.value} value={res.value}>
                      {res.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={6} className="mt-3">
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Subject</Form.Label>
                <Form.Select
                  name="subject_id"
                  onChange={handleChange}
                  value={assignmentData.subject_id}
                  required
                >
                  <option key="default" value="">
                    -- Select Subject --
                  </option>
                  {assignsubject.map((sub) => (
                    <option key={sub.value} value={sub.value}>
                      {sub.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col lg={6} className="mt-3">
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  required
                  placeholder="Enter title"
                  value={assignmentData.title}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={6} className="mt-3">
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Status</Form.Label>
                <Form.Select
                  name="status"
                  onChange={handleChange}
                  value={assignmentData.status}
                  required
                >
                  <option value="">-- Select Status --</option>
                  {assignmentStatus.map((res) => (
                    <option key={res.label} value={res.value}>
                      {res.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col lg={6} className="mt-3">
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Assign Date</Form.Label>
                <DatePicker
                  required
                  selected={assignmentData.assign_date}
                  onChange={(date) => handleDateChange(date, "assign_date")}
                  dateFormat="dd-MM-yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="Select a date"
                  className="form-control"
                  onKeyDown={(e) => e.preventDefault()}
                  highlightDates={[new Date()]}
                  minDate={new Date()}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={6} className="mt-3">
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Due Date</Form.Label>
                <DatePicker
                  required
                  selected={assignmentData.due_date}
                  onChange={(date) => handleDateChange(date, "due_date")}
                  dateFormat="dd-MM-yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="Select a date"
                  className="form-control"
                  onKeyDown={(e) => e.preventDefault()}
                  highlightDates={[new Date()]}
                  minDate={assignmentData.assign_date || new Date()}
                />
              </Form.Group>
            </Col>
            <Col lg={6} className="mt-3">
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Session</Form.Label>
                <Form.Select
                  name="session_id"
                  onChange={handleChange}
                  value={assignmentData.session_id}
                  required
                >
                  <option value="">-- Select Session --</option>
                  {sessionOptions.map((res) => (
                    <option key={res.label} value={res.value}>
                      {res.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={12} className="mt-3">
              <Form.Group className="mx-3">
                <Form.Label>Document:</Form.Label>
                <Form.Control
                  type="file"
                  name="document"
                  accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.csv,.txt,.jpg,.jpeg,.png,.gif"
                  onChange={handleDocumentChange}
                />
                {fileName && (
                  <Form.Text className="text-muted">{fileName}</Form.Text>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={12} className="mt-3 mb-4">
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Description</Form.Label>
                <Form.Control
                  as="textarea"
                  name="description"
                  placeholder="Enter description"
                  value={assignmentData.description}
                  onChange={handleChange}
                  className="textarea-style"
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleSubmit} disabled={isSubmitting}>
          {props.btnName}
        </Button>
        <Button
          variant="light"
          onClick={() => {
            props.handleCloseModal();
            resetFormState();
            
          }}
          
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateAssignmentModal;